const getS3ImageUrl = () => {
    if (window.location.hostname.includes('dev.' ) || window.location.hostname.includes('devx.') || window.location.hostname.includes('localhost')) {
        return 'https://d2ubvlyv5rhtko.cloudfront.net';
    } else if (window.location.hostname.includes('int.') || window.location.hostname.includes('intx.')) {
        return 'https://d3qxpq8rta17rf.cloudfront.net';
    } else {
        return 'https://thumbs.intersoftcdn.com';
    }
};

export default getS3ImageUrl;
